import { InjectionToken } from '@angular/core';

export const HOST_URL = new InjectionToken<string>('HostUrl');
